import React from 'react';
import './Stub.css';

function Artwork() {
  return (
    <div className="stub-page">
      <h1>Artwork</h1>
      <p>Coming soon.</p>
    </div>
  );
}

export default Artwork;
